import template from './report_general_statistics.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

let chart;
class ReportGeneralStatisticsViewModel
{
	constructor (page)
	{
		this.page = page;
		this.loader = ko.observable(false);

		this.current_department_id = ko.observable();
		this.current_company_id = ko.observable();
		this.selected_company = ko.observable();
		this.selected_department = ko.observable();
		this.selected_from_date = ko.observable(moment().subtract(1, 'years').format('YYYY-MM-DD'));
		this.selected_to_date = ko.observable(moment().format('YYYY-MM-DD'));

		this.selected_company.subscribe((newValue) => {
			if (newValue != null)
				this.current_company_id(newValue.company_id);
			else
				this.current_company_id(null);
		});

		this.selected_department.subscribe((newValue) => {
			if (newValue != null)
				this.current_department_id(newValue.department_id);
			else
				this.current_department_id(null);
		});

		this.end_date_timeout = null;
		this.start_date_timeout = null;

		this.selected_from_date.subscribe((newValue) => {
			if (!newValue) return;

			// Clear any existing timeout
			if (this.start_date_timeout)
				clearTimeout(this.start_date_timeout);
			this.start_date_timeout = setTimeout(() => {
				let sd = moment(newValue, 'YYYY-MM-DD', true);
				if (!sd.isValid()) return;

				// Update end date to last day of start date month
				let month_end = moment(sd).endOf('month').format('YYYY-MM-DD');
				this.selected_to_date(month_end);
			}, 500);
		});

		this.selected_to_date.subscribe((newValue) => {
			if (!newValue) return;

			// Clear any existing timeout
			if (this.end_date_timeout)
				clearTimeout(this.end_date_timeout);

			// Set new timeout to wait for user to finish typing
			this.end_date_timeout = setTimeout(() => {
				let ed = moment(newValue, 'YYYY-MM-DD', true);
				if (!ed.isValid()) return;

				if (newValue.length === 10)
				{
					let sd = moment(this.selected_from_date(), 'YYYY-MM-DD', true);
					if (sd.isValid() && ed.isBefore(sd))
					{
						Grape.alerts.alert({ type: 'error', title: tr('Invalid Date Range'), message: tr('End date cannot be before start date') });
						return;
					}
				}
			}, 1000);
		});
	}
}

class ReportGeneralStatisticsPage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new ReportGeneralStatisticsViewModel(this);
	}

	async init()
	{
		// check access to page
		if (await Utils.redirectOnAccessDenied('DiversityStatisticsReport'))
			return;

		document.title = tr('Diversity Statistics Report');
		window.current_page_title(tr('Diversity Statistics Report'));
	}

	updateData()
	{
		if (
			(this.viewModel.current_department_id() != null || this.viewModel.current_company_id())&&
			this.viewModel.selected_from_date() != null &&
			this.viewModel.selected_to_date() != null
		)
			this.updateReportData();

		this.setupGraph();
	}

	setupGraph()
	{
		chart = c3.generate({
			data: {
				// iris data from R
				columns: [],
				type: 'pie',
				onclick: (d, i) => { },
				onmouseover:  (d, i) => { },
				onmouseout: (d, i) => { }
			}
		});
	}

	buildGraph(res)
	{
		if (res != null)
		{
			let dataArray = []; // reset

			for (let a = 0; a < res.length; a++)
			{
				dataArray.push(new Array(res[a].race, res[a].cnt));
			}

			chart.unload(); // clear chart

			setTimeout( () => {
				chart.load({
					columns: dataArray
				});
			}, 1100);
		}
		else
			chart.unload(); // clear chart
	}

	async updateReportData()
	{
		let data = {
			department_id: this.viewModel.current_department_id(),
			company_id: this.viewModel.current_company_id(),
			date_start: this.viewModel.selected_from_date(),
			date_end: this.viewModel.selected_to_date()
		};

		this.viewModel.loader(true);

		let res = await Grape.fetches.postJSON('/reports/race_by_department', data);

		if (res)
		{
			this.buildGraph(res);
			this.viewModel.loader(false);
		}
	}

	show_report_help()
	{
		Grape.dialog.open('DiversityStatisticsReportHelp', { 'employee_id': this.bindings.id }, {});
	}
}

export default {
	route: '[/]report/report_general_statistics',
	page_class: ReportGeneralStatisticsPage,
	template: template,
	template_filename: 'translation/report_general_statistics'
};
